
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/used-to-explanation';
const mainimage = '/Images/usedto.webp';

const sections = [
  { label: "Grammar Quiz", description: "Do this exercise to practice used to.", type: "quiz", subtype: "usedto" },
];

const Usedto = () => (
  <GrammarPageLayout
    level="B1"
    title="Used to"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English “Used to” Exercises"
    seoDescription="Practice Used to with interactive exercises for B2 level English exams."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Usedto;

